import React from 'react';
import {TextField} from "@mui/material";

const MaterialTextFieldObjectWithEntityListCutDefault = ({
                                                   entityList,
                                                   label,
                                                   value,
                                                   setValue,
                                                   field,
                                                   disabled,
                                                   excludeStatus
                                               }) => {

    return (
        <div>
            <TextField
                autoComplete={"off"}
                size={"small"}
                disabled={disabled}
                key={field}
                sx={{
                    width: '370px',
                    gap: '1.5rem',
                }}
                margin="normal"
                select
                label={label}
                value={value === null ? "" : value}
                name={field}
                onChange={(e) =>
                    setValue(e.target.value)
                }
                SelectProps={{
                    native: true,
                }}
            >
                {Object.keys(entityList).map((statusKey) => (
                    excludeStatus !== statusKey && <option key={statusKey} value={statusKey}>
                        {entityList [statusKey]}
                    </option>
                ))}
            </TextField>
        </div>
    );
};

export default MaterialTextFieldObjectWithEntityListCutDefault;